import React from "react";
import { CSRPillAnchor, DisableCSRPillAnchor } from "./styles";
import pencil from "../../assets/icons/edit.svg";
import pencil_disable from "../../assets/icons/edit_disable.svg";
import { recordError } from "../../utils/commonUtil";
import PropTypes from "prop-types";

export const routeTo = (toGeminiApp, linkPathname) => {
  try {
    if (toGeminiApp) {
      window.location.replace(`${process.env.REACT_APP_GEMINI_CSR_URL}${linkPathname}`)
    }
  } catch(error) {
    recordError(error);
  }
}
function CSREditLinkToPill(props) {  
    const { className, linkPathname, toGeminiApp, disabled } = props;    
    if (disabled) {
      return (
        <div className={'not-allowed-cursor'} data-test="csr-disabled-edit-button">
          <DisableCSRPillAnchor disabled={true} onClick={() => { routeTo(toGeminiApp, linkPathname) }} className={className}>
            <span style={{ color: "#d9d9d9" }}>CSR Edit</span>
            <img src={pencil_disable} className="ml-05" alt="pencil_disable" />
          </DisableCSRPillAnchor>
        </div>
      )
    } else {
      return (
        <CSRPillAnchor className={className} onClick={() => { routeTo(toGeminiApp, linkPathname) }} data-test="csr-edit-button">
          <span>CSR Edit</span>
          <img src={pencil} className="ml-05" alt="pencil" />
        </CSRPillAnchor>
      )
    }
}

CSREditLinkToPill.propTypes = {
  disabled: PropTypes.bool,
  linkPathname: PropTypes.string,
  toGeminiApp: PropTypes.bool
}

export default CSREditLinkToPill;
